import { useQuery } from '@tanstack/react-query';
import consentTemplatesApi from '@/features/dashboard/consentTemplates/api/consentTemplatesApi.ts';
import { consentTemplatesApiQueryKeys } from '@/features/dashboard/consentTemplates/api/consentTemplatesApi.queryKeys.ts';

const useGetConsentTemplates = () => {
  return useQuery({
    queryKey: consentTemplatesApiQueryKeys.all(),
    queryFn: () =>
      consentTemplatesApi.getAll(
        { page: 0, size: 100 },
        { filters: [], combinator: 'AND', searchTerm: '', quickFilters: {} },
      ),
    select: (data) => data.content,
  });
};

export default useGetConsentTemplates;
